
import TableList from "@components/templates/tablelist";
import { mapState,mapGetters } from "vuex";
import { HttpGetRecommendList } from "@/service/proddevelop";
import { HttpGetCategories } from '@/service/products/allproducts'
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left",
            },
            categoryList:[],
        };
    },
    created(){
        this.getcategory();
    },
    methods: {
        
        ajaxRequest: HttpGetRecommendList,
        interceptRequest(params) {
            params.search.EQ_status = 2;
            return params
        },
        getcategory(){
            HttpGetCategories().then(res=>{
                this.categoryList = res.data.filter(item=>{
                    return item.level == 3
                })
            })
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getAllProductPerson']),
        SearchsData() {
            return [
            {
                label: "标题",
                key: 'CN_title',
                tag: 'vInput',
                show: true,
            },
            {
                label: "品类",
                key: 'EQ_categoryId',
                tag: 'Select',
                options: this.categoryList.map(item=>{
                    return {
                        value:item.id,
                        label:item.code+'-'+item.name
                    }
                }),
                props:{
                    filterable:true,
                },
                show: true,
            },
            {
                label: "项目",
                key: 'EQ_lineId',
                tag: 'Select',
                options:this.getNewProductList,
                props:{
                    filterable:true,
                },
                show: true,
            },
            {
                label: "来源",
                tag: 'vInput',
                key: 'CN_source',
                show: true,
            }]
        },
        columns() {
            return [{
                title: "新品推荐编号",
                key: 'id',
                width: 60,
            }, {
                title: "标题",
                key: 'title'
            }, {
                title: "品类",
                render:(h,{row})=>{
                    const id = row.categoryId;
                    const category = this.categoryList.filter((item) => {
                        return id == item.id
                    })[0] || {};
                    return (
                    <div>
                        <div>
                            {category.code +'-'+ category.name}
                        </div>
                        
                    </div>
                    )
                }
            }, {
                title: "项目",
                render: (h, { row }) => this.findRenderLabel(this.getNewProductList, row.lineId),
            },
            {
                title: "来源",
                key: 'source'
            },
            {
                title: "操作",
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, "选择")
                }
            }]
        }
    }

};
